import { Injectable } from '@angular/core';

@Injectable()
export class BusyIndicatorService {

  constructor() { }

  private _Counter = 0;
  public get Counter() {
    return this._Counter;
  }

  Elapsed: number;

  Start() {
    if (this._Counter == 1) {
      return;
    }

    this._Counter = 1;
    this.Elapsed = 0;
    this.StartTimer();
  }

  Finish() {
    this._Counter = 0;
  }

  StartTimer() {
    setTimeout(() => {
      this.Elapsed += 1;

      if (this._Counter > 0) {
        this.StartTimer();
      }
    }, 1000);
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/busy-indicator/busy-indicator.service.ts